import { Link } from 'react-router-dom';
import { Tooltip } from 'antd';
import { FiPlus, FiHelpCircle } from 'react-icons/fi';
import { PiEyeLight } from 'react-icons/pi';
import { LiaEdit, LiaTrashAlt } from 'react-icons/lia';
import Table from '../../components/Table';
import SelectDropdown from '../../components/common/SelectDropdown';
import shared from './shared';
import Layout from '../../components/global/layout';
import methodModel from '../../methods/methods';
import { useSelector } from 'react-redux';
import { statusModel } from '../../models/Status.model';
import { useEffect, useState } from 'react';
import ApiClient from '../../methods/api/apiClient';
import { Routes } from '../../methods/ApiRoutes';
import MultiSelectDropdown from '../../components/common/MultiSelectDropdown';
import { FaEye } from 'react-icons/fa';
import CustomModal from '../../components/common/CustomModal';

function Html({
  sorting,
  openModal,
  closeModal,
  isModalVisible,
  selectedMessage,
  filter,
  edit,
  view,
  statusChange,
  pageChange,
  count,
  deleteItem,
  clear,
  filters,
  setFilter,
  loaging,
  data,
  changestatus,
  total,
  sortClass,
}) {
  const [venueList, setVenueList] = useState([]);
  const [isHelpModalVisible, setIsHelpModalVisible] = useState(false);
  useEffect(() => {
    ApiClient.get(Routes.Venue.listApi, { status: 'active', page: 1, count: 2000 }).then(res => {
      if (res.success) {
        setVenueList(res?.data?.map(item => ({ ...item, id: item?._id || item?.id, name: item?.name || item?.venueName })));
      }
    });
  }, []);
  const user = useSelector(state => state.user);
  const columns = [
    {
      key: 'title',
      name: 'Title',
      render: (row) => <span className="capitalize">{row?.title || row?.type || '--'}</span>,
    },
    {
      key: "message",
      name: "Message",
      render: (row) => {
        const message = row?.message || row?.discription || "--";
        const maxLength = 30;

        const isLong = message.length > maxLength;
        const truncatedText = isLong
          ? `${message.slice(0, maxLength)}...`
          : message;

        return (
          <span className="capitalize">
            {truncatedText}

            {isLong && (
              <button
                type="button"
                className="ml-1 text-blue-600 hover:underline text-[10px]"
                onClick={() => openModal(row?._id || row?.id)}
              >
                see more
              </button>
            )}
          </span>
        );
      },
    },
    {
      key: 'venueIds',
      name: 'Venues',
      render: (row) => {
        const ids = row?.venueIds || [];
        return ids.length > 0 ? (
          <Tooltip
            placement="top"
            title={
              <div className="flex flex-col gap-2 max-h-48 overflow-y-auto pr-1">
                {ids.map((v, i) => (
                  <div key={i} className="flex items-center gap-2">
                    <img
                      src={methodModel.noImg(v?.logo || v?.image || v?.profileImage || v?.bannerImage)}
                      alt="venue"
                      className="w-6 h-6 rounded-full object-cover bg-white"
                      onError={(e) => { e.target.src = methodModel.noImg(); }}
                    />

                    <span className="text-sm capitalize">{v?.name || v?.venueName || '--'}</span>
                  </div>
                ))}
              </div>
            }
          >
            <span className="bg-[#CC9900]/10 text-[#CC9900] text-xs px-2 py-0.5 rounded-full cursor-pointer" >
              {ids.length} venue{ids.length > 1 ? 's' : ''}
            </span>
          </Tooltip>
        ) : <span className="text-gray-400">--</span>;
      },
    },
    {
      key: 'customerIds',
      name: 'Customers',
      render: (row) => {
        const ids = row?.customerIds || row?.to || [];
        return ids.length > 0 ? (
          <>
            <Tooltip
              placement="top"
              title={
                <div className="flex flex-col gap-2 max-h-48 overflow-y-auto pr-1">
                  {ids.map((c, i) => (
                    <div key={i} className="flex items-center gap-2">
                      <img
                        src={methodModel.noImg(c?.image || c?.profileImage || c?.bannerImage)}
                        alt="user"
                        className="w-6 h-6 rounded-full object-cover bg-white"
                        onError={(e) => { e.target.src = methodModel.noImg(); }}
                      />
                      <span className="text-sm capitalize">{c?.fullName || c?.name || c?.firstName || '--'}</span>
                    </div>
                  ))}
                </div>
              }
            >
              <span className="bg-blue-50 text-blue-600 text-xs px-2 py-0.5 rounded-full cursor-pointer">
                {ids.length} customer{ids.length > 1 ? 's' : ''}
              </span>
            </Tooltip>
          </>
        ) : <span className="text-gray-400">--</span>;

      },
    },
    {
      key: 'action',
      name: 'Action',
      render: (itm) => (
        <div className="flex items-center justify-start gap-1.5">
          <Tooltip placement="top" title="View">
            <a onClick={() => view(itm.id)} className="cursor-pointer rounded-full w-8 h-8 flex items-center justify-center text-sm hover:opacity-80 bg-[#E5EFFD] text-[#005AEF]">
              <FaEye />
            </a>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <>
      <Layout>
        <div className="flex flex-wrap justify-between items-center gap-y-4 mb-5">
          <div>
            <h3 className="text-2xl font-semibold text-[#111827]">{shared.title}</h3>
          </div>
          <div className="flex">
            {methodModel?.hasPermission(user, shared.permissionKey, 'edit') && <Link className="bg-primary leading-10 h-10 flex justify-center  items-center shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-full gap-1 cursor-pointer min-w-[94px]" to={`/${shared.url}/add`}>
              <FiPlus className="text-lg text-white" />
              {' '}
              Add
              {shared.addTitle}
            </Link>}
          </div>
        </div>
        <div className="">
          <div className="flex items-center flex-wrap gap-2 mb-4">
            <form className="flex items-center max-w-sm gap-2" onSubmit={(e) => { e.preventDefault(); filter(); }}>
              <label htmlFor="simple-search" className="sr-only">Search</label>
              <div className="relative w-full">
                <input
                  type="text"
                  id="simple-search"
                  value={filters.search}
                  onChange={(e) => {
                    setFilter({ ...filters, search: e.target.value });
                    if (e.target.value == '') filter({ search: '' })
                  }}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full focus:ring-orange-500 focus:border-[#063688] block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-orange-500 dark:focus:border-orange-500 h-10 px-5 pr-11"
                  placeholder="Search....."
                />
                {filters?.search && (
                  <i className="fa fa-times absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 text-sm" aria-hidden="true" onClick={(e) => clear()} />
                )}
                <button type="submit" className="text-[#2D2D2D] absolute top-[13px] right-[15px] hover:opacity-80">
                  <svg
                    className="w-4 h-4"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 20"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                    />
                  </svg>
                  <span className="sr-only">Search</span>
                </button>
              </div>

            </form>
            <div className="flex gap-2 ml-auto">
              <div className="w-[300px]">
                <MultiSelectDropdown
                  id="venueFilter"
                  displayValue="name"
                  placeholder="All Venues"
                  theme="search"
                  isClearable={false}
                  intialValue={filters?.venueIds}
                  result={(e) => {
                    changestatus(e.value, 'venueIds');
                  }}
                  options={venueList}
                />
              </div>
            </div>
          </div>
          {!loaging ? (
            <Table
              className="mb-3"
              data={data}
              columns={columns}
              page={filters.page}
              count={filters.count}
              filters={filters}
              total={total}
              result={(e) => {
                if (e.event == 'page') pageChange(e.value);
                if (e.event == 'sort') {
                  sorting(e.value);
                  sortClass(e.value);
                }
                if (e.event == 'count') count(e.value);
              }}
            />
          ) : (
            <div className="py-20 text-center text-gray-400">Loading Notifications...</div>
          )}
          <CustomModal
            open={isModalVisible}
            onClose={closeModal}
            width={700}
          >
            {selectedMessage && (
              <div className="bg-white rounded-lg p-5">
                <h4 className="text-lg font-semibold text-gray-800 mb-3">
                  Message
                </h4>

                <div className="max-h-80 overflow-y-auto pr-2">
                  <p className="text-gray-600 text-sm leading-7 whitespace-pre-wrap break-words">
                    {selectedMessage.message || "--"}
                  </p>
                </div>
              </div>
            )}
          </CustomModal>

        </div>

        {/* How It Works Guide Modal */}
        <CustomModal
          open={isHelpModalVisible}
          onClose={() => setIsHelpModalVisible(false)}
          width={650}
        >
          <div className="flex flex-col font-sans">
            {/* Header */}
            <div className="bg-gradient-to-r from-[#CC9900] via-[#E6B800] to-[#CC9900] p-6 text-white relative">
              <div className="flex justify-between items-start gap-4">
                <div>
                  <h3 className="text-xl font-bold leading-snug">
                    💡 How Notifications Work
                  </h3>
                  <p className="text-sm text-white/90 mt-1">
                    Learn how notifications are sent and tracked in the system
                  </p>
                </div>
              </div>
            </div>

            {/* Ticket Dotted Separator */}
            <div className="relative bg-gray-50" style={{ height: '28px' }}>
              <svg className="absolute left-0 top-0 h-full" style={{ width: '14px' }} viewBox="0 0 14 28" preserveAspectRatio="none">
                <path d="M0,0 C14,0 14,28 0,28 Z" fill="white" />
              </svg>
              <div className="absolute" style={{ top: '50%', left: '14px', right: '14px', transform: 'translateY(-50%)', borderTop: '1.5px dashed #d1d5db' }} />
              <svg className="absolute right-0 top-0 h-full" style={{ width: '14px' }} viewBox="0 0 14 28" preserveAspectRatio="none">
                <path d="M14,0 C0,0 0,28 14,28 Z" fill="white" />
              </svg>
            </div>

            {/* Modal Body */}
            <div className="p-6 space-y-6">
              <p className="text-sm text-gray-600 leading-relaxed">
                TavLoy's notification management dashboard allows you to directly broadcast messages to customer devices.
              </p>

              <div className="space-y-4">
                {/* Step 1 */}
                <div className="flex gap-4 p-4 rounded-xl border border-gray-100 bg-gray-50/50">
                  <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-orange-50 text-orange-500 font-bold text-sm flex-shrink-0">1</span>
                  <div>
                    <h4 className="font-bold text-[#8B6E1E] text-sm mb-1">Create Notification</h4>
                    <p className="text-xs text-gray-600 leading-relaxed">
                      Click the **+ Add Notification** button to target specific venues, search for particular customers, or broadcast to everyone.
                    </p>
                  </div>
                </div>

                {/* Step 2 */}
                <div className="flex gap-4 p-4 rounded-xl border border-gray-100 bg-gray-50/50">
                  <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-blue-50 text-blue-600 font-bold text-sm flex-shrink-0">2</span>
                  <div>
                    <h4 className="font-bold text-[#8B6E1E] text-sm mb-1">Interactive Tooltips (Badges)</h4>
                    <p className="text-xs text-gray-600 leading-relaxed">
                      Hover over any **Venue** count or **Customer** count badge in the listing table to directly see the list of targeted venues or customers in a popover tooltip.
                    </p>
                  </div>
                </div>

                {/* Step 3 */}
                <div className="flex gap-4 p-4 rounded-xl border border-gray-100 bg-gray-50/50">
                  <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-50 text-yellow-600 font-bold text-sm flex-shrink-0">3</span>
                  <div>
                    <h4 className="font-bold text-[#8B6E1E] text-sm mb-1">Automatic Real-Time Push</h4>
                    <p className="text-xs text-gray-600 leading-relaxed">
                      Once saved, the system **automatically delivers push notifications** directly to target customers' mobile devices in real time.
                    </p>
                  </div>
                </div>

                {/* Step 4 */}
                <div className="flex gap-4 p-4 rounded-xl border border-gray-100 bg-gray-50/50">
                  <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-green-50 text-green-600 font-bold text-sm flex-shrink-0">4</span>
                  <div>
                    <h4 className="font-bold text-[#8B6E1E] text-sm mb-1">Tracking and History</h4>
                    <p className="text-xs text-gray-600 leading-relaxed">
                      All sent notifications remain visible on this page. You can view the specific target audience and details of past broadcasts at any time.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="bg-gray-50 px-6 py-4 border-t border-gray-100 flex justify-end">
              <button
                onClick={() => setIsHelpModalVisible(false)}
                className="px-5 py-2 rounded-xl border border-gray-200 text-gray-600 hover:bg-gray-100 transition-all text-xs font-semibold"
              >
                Got it, thanks!
              </button>
            </div>
          </div>
        </CustomModal>

        {/* Floating Help Button */}
        <Tooltip placement="left" title="How It Works">
          <button
            type="button"
            onClick={() => setIsHelpModalVisible(true)}
            className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-12 h-12 rounded-full bg-[#CC9900] text-white shadow-lg hover:bg-[#B38000] hover:scale-110 active:scale-95 transition-all duration-300"
          >
            <FiHelpCircle className="text-2xl" />
          </button>
        </Tooltip>
      </Layout>
    </>
  );
}

export default Html;
